import { useMutation, UseMutationConfig } from '@libs/use';
import { OrderItem } from '@libs/api-reference';
import { unref } from 'vue';

import * as API from '../requests';
import { CreateOrderFormModel } from './useCreateOrderQuery';

type EditOrderFormModel = CreateOrderFormModel & {
  remainingQuantity: number;
};

function updateOrderFactory({
  formModel,
  order,
  orderExecutionType,
  deviceType,
}: {
  formModel: EditOrderFormModel;
  order: OrderItem;
  deviceType: number;
  orderExecutionType: string;
}) {
  return {
    ...formModel,
    instrumentIdentification: order.instrumentIdentification as string,
    accountRouteTypeId: order.accountRouteType,
    orderExecutionType,
    orderSide: Number(order.orderSideId),
    parentId: order.orderId,
    investorBourseCodeId: 0,
    validateAssetOnSell: false,
    deviceType,
  };
}

type UseUpdateOrderOptions = {
  order?: OrderItem;
  deviceType: number;
  orderExecutionType: string;
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useUpdateOrderQuery({
  order,
  deviceType,
  orderExecutionType,
  onReject,
  onSuccess,
}: UseUpdateOrderOptions) {
  const {
    execute: updateOrder,
    isPending: isLoadingUpdateOrder,
    isError: isErrorUpdateOrder,
    ...query
  } = useMutation(
    ({ formModel }: { formModel: EditOrderFormModel }) =>
      API.updateOrder(
        updateOrderFactory({
          formModel,
          orderExecutionType,
          order: unref(order as OrderItem),
          deviceType,
        })
      ),
    {
      onSuccess,
      onReject,
    }
  );

  return { updateOrder, isLoadingUpdateOrder, isErrorUpdateOrder, ...query };
}
